import { Grid, Typography } from '@mui/material';
import images from 'assets/images';
import React from 'react';
import { Container } from '@mui/system';
import Slider from 'react-slick';
import { testimonialsTimeLineObj } from 'assets/animation/portalAnimation';

const settingsTest = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
};

const Flexibility: React.FC = () => {
    const testimonialsTimeLine = React.useRef(null);

    React.useEffect(() => {
        testimonialsTimeLineObj(testimonialsTimeLine);
    }, []);

    return (
        <section className="testimonials" ref={testimonialsTimeLine}>
            <Container maxWidth="lg">
                <Grid container spacing={5}>
                    <Grid item xs={12} lg={6}>
                        <div className="testimonials-mockup">
                            <div className="block-layer">
                                <div className="circle top"></div>
                                <div className="color-layer">
                                    <div className="custom-grid">
                                        <span>
                                            <img src={images.testImage1} alt="Image" />
                                        </span>
                                        <span className="inner-grid">
                                            <img src={images.testImage2} alt="Image" />
                                            <img src={images.testImage3} alt="Image" />
                                        </span>
                                    </div>
                                </div>
                                <div className="circle bottom"></div>
                            </div>
                        </div>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <div className="testimonials-content">
                            <div className="slider-block dymond-slider">
                                <Slider {...settingsTest}>
                                    <div className="text-block">
                                        <Typography variant="h3" className="section-title">
                                            Flexibility – From Public to Private
                                        </Typography>
                                        <Typography variant="body1">
                                            Dr Mary was a full-time public psychiatrist who juggled long hours and
                                            family life. She faced the usual challenges – the need to juggle school
                                            drops and pick-ups, spending time with family, and achieving financial
                                            freedom.
                                        </Typography>
                                        <Typography variant="body1">
                                            She has considered leaving public work but worried about losing financial
                                            security and peer support. She considered private practice, but the costs
                                            were prohibitive (rentals, employing admin staff, IT requirements,
                                            accounting, etc). Renting a room in an established practice often means
                                            30-40% of your income. Joining a private hospital offers cost reductions but
                                            needs a commitment to maintaining a certain number of in-patients and being
                                            available “on-call”.
                                            <br />
                                            Moreover, all these options were not really flexible, with the facilities
                                            operating on a 9 to 5 basis.
                                        </Typography>
                                        <Typography variant="body1">
                                            With Healthreach, Mary could work some of her spare time in the evenings or
                                            weekends and from the comfort of her home. She did not have to worry about
                                            the administrative burden, and costs were low. She is much happier and more
                                            comfortable with the flexibility offered by Healthreach.
                                        </Typography>
                                    </div>
                                    <div className="text-block">
                                        <Typography variant="h3" className="section-title">
                                            Lower Cost – Your Referral Network, Our Admin
                                        </Typography>
                                        <Typography variant="body1">
                                            Ms Sam is a clinical psychologist who works in a physical, non-telehealth
                                            clinic. The clinic takes a significant proportion of her earnings as
                                            administrative/ service fee. Ms Sam has considered changing to other
                                            clinics, but found that they all charge around 30-50% of her earnings
                                            depending on their location.
                                        </Typography>
                                        <Typography variant="body1">
                                            Sam considered practicing from her own home because she has a strong network
                                            of GPs who consistently refers to her. She was fearful of excessive
                                            administrative burden, maintaining her secure documentation system and
                                            spending her own time taking phone calls.
                                        </Typography>
                                        <Typography variant="body1">
                                            When Sam found Healthreach, she was happy with the administrative support
                                            and the lower cost. She was able to slowly shift new referrals to
                                            Healthreach while maintaining her current practice. In a few months’ time,
                                            Sam realised that she no longer need to practice physically. She is now
                                            enjoying the extra savings and time, as well as benefiting from
                                            Healthreach’s existing referral GP network.
                                        </Typography>
                                    </div>
                                </Slider>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Container>
        </section>
    );
};

export default React.memo(Flexibility);
